import { PageHeader } from '@/components/layout/PageHeader';
import { getApiBaseUrl } from '@/config/env';

const SAMPLE_EVENTS = `[
  {
    "event": "open",
    "trackingToken": "<32-char-hex-token-from-send-queue>"
  },
  {
    "event": "click",
    "trackingToken": "<32-char-hex-token-from-send-queue>"
  }
]`;

const SECRET_HEADER = 'X-Marketing-Webhook-Secret';

export function MarketingEspWebhooksPage() {
  const apiBase = getApiBaseUrl();

  return (
    <div className="space-y-6">
      <PageHeader
        title="ESP webhooks"
        description="SendGrid, Mailgun, and similar providers POST open/click events to update campaign metrics"
        breadcrumbs={[
          { label: 'Org', to: '/org' },
          { label: 'Marketing', to: '/marketing' },
          { label: 'ESP webhooks' },
        ]}
      />

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="card p-4 space-y-3">
          <h3 className="font-semibold text-sm">Endpoints</h3>
          <p className="text-sm text-slate-600">
            Configure your ESP to POST a JSON array. Each event needs <code>event</code> or <code>type</code> (open/click)
            and a valid 32-character hex <code>trackingToken</code> from the campaign send queue.
          </p>
          <p className="text-sm text-slate-600">
            When <code>MARKETING_ESP_WEBHOOK_SECRET</code> is set on the server, include header{' '}
            <code>{SECRET_HEADER}</code> with the same value.
          </p>
          <div className="rounded bg-slate-50 p-3 text-xs font-mono break-all">
            POST {apiBase}/v1/marketing/webhooks/sendgrid
          </div>
          <div className="rounded bg-slate-50 p-3 text-xs font-mono break-all">
            POST {apiBase}/v1/marketing/webhooks/mailgun
          </div>
          <div className="rounded bg-slate-50 p-3 text-xs font-mono break-all">
            POST {apiBase}/v1/marketing/webhooks/custom
          </div>
        </div>

        <div className="card p-4">
          <h3 className="font-semibold text-sm mb-2">Sample payload</h3>
          <pre className="text-xs bg-slate-50 p-3 rounded overflow-x-auto">{SAMPLE_EVENTS}</pre>
        </div>
      </div>

      <div className="card p-4 text-sm text-slate-600">
        <p>
          After a campaign send, tokens are stored on the send queue. Opens and clicks flow into{' '}
          <code>MarketingTrackingService</code> and appear on campaign performance and attribution reports.
        </p>
      </div>
    </div>
  );
}
